export interface ImageControls {
  exposure: number;
  reinhardWhite: number;
  sigmoidMidpoint: number;
  sigmoidSteepness: number;
  bloomStrength: number;
  bloomThreshold: number;
  bloomScatter: number;
  motionBlurAmount: number;
}

export const imageControls: ImageControls = {
  exposure:         1.5,
  reinhardWhite:    4.0,
  sigmoidMidpoint:  0.6,
  sigmoidSteepness: 4.5,
  bloomStrength:    0.05,
  bloomThreshold:   0.61,
  bloomScatter:     2.0,
  motionBlurAmount: 1.0,
};
